import i18n from "i18next";
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/julien.json';
import frTranslation from './locales/fr/julien.json';
import enKeysTranslation from './locales/en/keys.json';
import snKeysTranslation from './locales/sn/keys.json';
import frKeysTranslation from './locales/fr/keys.json';
import fullTranslation from './locales/fr/ju_full.json';
import snTranslation from './locales/sn/julien.json';
import languagedetector from "i18next-browser-languagedetector";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(languagedetector)
  .init({
      load: 'languageOnly',
    resources: {
      en: { 
        julien: enTranslation, // Define the 'julien' namespace for 'en'
        keys: enKeysTranslation,
        full: fullTranslation
      },
      sn: {
        julien: snTranslation, // Define the 'julien' namespace for 'fr'
        keys: snKeysTranslation,
        full: fullTranslation
      },
      fr: {
        julien: frTranslation, // Define the 'julien' namespace for 'fr'
        keys: frKeysTranslation,
        full: fullTranslation
      },
    },
    // lng: "fr",
    fallbackLng: "fr",
    detection: {
      order: ['querystring', 'navigator'],
    },
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;